import { render, staticRenderFns } from "./btnCompanyEdit.vue?vue&type=template&id=67dd9d40"
import script from "./btnCompanyEdit.vue?vue&type=script&lang=js"
export * from "./btnCompanyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports